export default __webpack_public_path__ + "static/media/photo_5282747746622312911_y.520b13e5.jpg";